module.exports = __webpack_public_path__ + "static/media/buzzphoto.08937155.jpg";